import React, { useState } from "react";
import { useGetRecipeByIdQuery } from "../../../providers/recipes";
import Page from "../../page-layout";
import MaxWidthContainer from "../../../components/UI/MaxWidthContainer/MaxWidthContainer";
import { BackButton } from "../../../parhato2/src/entities";
import { useHistory, useParams } from "react-router-dom";
import { Image } from "../../../components/Image/Image";
import { useGetIncludeProductsQuery } from "../../../providers/products";
import { useActiveOrMainShippingZone } from "../../../providers/shippingZones";
import { AddToCartProduct, useCartData } from "../../../providers/cartDataStore";
import { useConfig } from "../../../providers/config";
import { useTranslation } from "react-i18next";

export type RecipeDetailParams = {
  id: string;
};

const RecipeCard = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const config = useConfig();
  const { addToCart } = useCartData();
  const { id } = useParams<RecipeDetailParams>();
  const [activeTab, setActiveTab] = useState<"ingredients" | "steps">("ingredients");

  const { data: recipes } = useGetRecipeByIdQuery({
    recipeById: Number(id),
  });

  const { activeShippingZone } = useActiveOrMainShippingZone();
  const activeShippingZoneId = activeShippingZone.id;

  const productIdsToInclude = recipes?.productIds ?? [];

  const { data: fetchedProducts } = useGetIncludeProductsQuery({
    include: productIdsToInclude,
    params: {
      zoneId: activeShippingZoneId,
    },
  });

  const handleAddIngredientsToCart = () => {
    if (fetchedProducts) {
      fetchedProducts.forEach((prod) => addToCart(prod as AddToCartProduct));
    }
    history.push("/cart");
  };

  return (
    <Page>
      <Page.Content>
        <div className="relative min-h-screen bg-gray-100">
          <MaxWidthContainer classList="">
            <div className="">
              <div className="!sticky top-0 left-0 w-full h-60 -z-10">
                <Image src={recipes?.image} className="w-full h-full object-cover" />
              </div>
              <BackButton buttonStyles="flex items-center absolute top-[4.4rem] left-4 z-20 bg-white/80 hover:bg-white p-2 h-[4rem] w-[4rem] rounded-lg" />
            </div>
            <div className="relative bg-white rounded-t-2xl md:rounded-t-3xl p-5 md:p-6 -mt-10 z-10 shadow-lg flex flex-col min-h-[calc(100vh-15rem)]">
              <h1 className="text-xl sm:text-2xl font-bold mb-1">{recipes?.title}</h1>
              <p className="text-sm text-gray-500 mb-4">{recipes?.description}</p>
              <div className="flex justify-around items-center mb-5 bg-gray-200 rounded-xl w-full">
                <button
                  onClick={() => setActiveTab("ingredients")}
                  className={` py-2 px-4 m-1 text-sm sm:text-base font-semibold rounded-xl transition-colors duration-200 w-full ${
                    activeTab === "ingredients" ? "bg-white" : "bg-gray-200"
                  }`}
                >
                  {t("Ingredients")}
                </button>
                <button
                  onClick={() => setActiveTab("steps")}
                  className={`py-2 px-4 m-1 text-sm sm:text-base font-semibold rounded-xl transition-colors duration-200 w-full ${
                    activeTab === "steps" ? "bg-white" : "bg-gray-200"
                  }`}
                >
                  {t("How to cook")}
                </button>
              </div>

              <div className="flex flex-col gap-2.5 pb-20">
                {activeTab === "ingredients" &&
                  recipes?.ingredients?.map((ingridient, i) => {
                    return (
                      <div key={i} className="flex justify-between items-center text-sm sm:text-base">
                        <div>{ingridient.name}</div>
                        <div className="text-gray-700 font-medium">
                          {ingridient.quantity} {ingridient.portionUnit}
                        </div>
                      </div>
                    );
                  })}
                {activeTab === "steps" && (
                  <div className="text-sm sm:text-base prose prose-sm max-w-none">
                    {recipes?.description ? (
                      <div>{recipes?.description}</div>
                    ) : (
                      <div className="text-gray-500">{t("There are no cooking instructions.")}</div>
                    )}
                  </div>
                )}
              </div>

              <div className="absolute bottom-0 left-0 right-0 px-5 md:px-6 pb-4 pt-2 bg-white ">
                <button
                  className="w-full bg-primary text-black font-bold py-3 px-4 rounded-xl"
                  onClick={() => {
                    handleAddIngredientsToCart();
                  }}
                >
                  {t("Order ingredients")}
                </button>
              </div>
            </div>
          </MaxWidthContainer>
        </div>
      </Page.Content>
    </Page>
  );
};

export default RecipeCard;
